import React, {useRef, useEffect} from "react";
import { Loader, LoaderSize, LoaderType } from "components/common/Loader.component";

export const AlternativePageView = ({pdf, zoom, rotation, index, style}: any): React.ReactElement => {
    const thisCanvas = useRef<HTMLCanvasElement>(null);
    const loadingImageRef = useRef<HTMLImageElement>(null);
    const renderTaskRef = useRef<any>(null);

    useEffect(() => {
        if (!pdf || index < 0) return;

        let cancelled = false;

        // Cancel any in-progress render before starting a new one
        if (renderTaskRef.current) {
            renderTaskRef.current.cancel();
            renderTaskRef.current = null;
        }

        pdf.getPage(index + 1).then(function (page) {
            if (cancelled) return;

            let viewport = page.getViewport({scale: zoom / 100, rotation: rotation});

            if (thisCanvas.current) {
                thisCanvas.current.height = viewport.height;
                thisCanvas.current.width = viewport.width;

                // Render PDF page into canvas context
                const renderContext = {
                    canvasContext: thisCanvas.current.getContext('2d'),
                    viewport: viewport
                };
                const renderTask = page.render(renderContext);
                renderTaskRef.current = renderTask;

                renderTask.promise.then(function () {
                    renderTaskRef.current = null;
                    loadingImageRef.current?.classList.add("hidden");
                }).catch(function (err) {
                    // Ignore cancellation errors
                    if (err?.name !== 'RenderingCancelledException') {
                        console.error('PDF render error:', err);
                    }
                });
            }
        }).catch(function (err) {
            if (!cancelled) {
                console.error('PDF getPage error:', err);
                renderTaskRef.current = null;
                loadingImageRef.current?.classList.add("hidden");
            }
        });

        return () => {
            cancelled = true;
            if (renderTaskRef.current) {
                renderTaskRef.current.cancel();
                renderTaskRef.current = null;
            }
        };
    }, [pdf, index, zoom, rotation]);

    if (!pdf || index < 0) return null;

    return <div style={style} className={"d-grid justify-content-center"}>
        <canvas id={"canvas_" + (index + 1)} ref={thisCanvas} className={"mt-16 d-block"}/>
        <span className={"mt-128 float-left"} ref={loadingImageRef} >
            <Loader type={LoaderType.Default} size={LoaderSize.Medium} /></span>
    </div>

};

export default AlternativePageView;
